import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["textContent"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_EditFunktionenDialog = _resolveComponent("EditFunktionenDialog")!

  return (_openBlock(), _createBlock(_component_v_col, null, {
    default: _withCtx(() => [
      _createVNode(_component_v_col, {
        class: "pb-0",
        sm: "12"
      }, {
        default: _withCtx(() => [
          _createElementVNode("h3", {
            textContent: _toDisplayString(_ctx.$t('einstellungen.funktion.title'))
          }, null, 8, _hoisted_1)
        ]),
        _: 1
      }),
      _createVNode(_component_v_col, {
        class: "pt-0",
        sm: "12"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_row, null, {
            default: _withCtx(() => [
              _createVNode(_component_v_col, {
                class: "py-6",
                sm: "12"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_icon, null, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.rechnungIcon), 1)
                    ]),
                    _: 1
                  }),
                  _createTextVNode(" " + _toDisplayString(_ctx.$t('einstellungen.funktion.zustellunglieferantenrechnung')) + " ", 1),
                  _cache[0] || (_cache[0] = _createElementVNode("br", null, null, -1)),
                  _createVNode(_component_v_icon, null, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.rechnungEmailIcon), 1)
                    ]),
                    _: 1
                  }),
                  _createTextVNode(" " + _toDisplayString(_ctx.$t('einstellungen.funktion.emaillieferantenrechnungnen')) + " " + _toDisplayString(_ctx.teilnehmerFunktionApiDto.emailLieferantRechnung) + " ", 1),
                  _cache[1] || (_cache[1] = _createElementVNode("br", null, null, -1)),
                  _createVNode(_component_v_icon, null, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.tvsIcon), 1)
                    ]),
                    _: 1
                  }),
                  _createTextVNode(" " + _toDisplayString(_ctx.$t('einstellungen.funktion.zustellungtvsdokumente')) + " ", 1),
                  _cache[2] || (_cache[2] = _createElementVNode("br", null, null, -1)),
                  _createVNode(_component_v_icon, null, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.tvsDokumenteEmailIcon), 1)
                    ]),
                    _: 1
                  }),
                  _createTextVNode(" " + _toDisplayString(_ctx.$t('einstellungen.funktion.emailtvsdokumente')) + " " + _toDisplayString(_ctx.teilnehmerFunktionApiDto.emailTvsDokument), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_EditFunktionenDialog, { "teilnehmer-funktion-api-dto": _ctx.teilnehmerFunktionApiDto }, null, 8, ["teilnehmer-funktion-api-dto"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}